import Vue from 'vue'
import Router from 'vue-router'
import { storGet } from '@/utils/request'
Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
// const monitor = !!(storGet('screen') && storGet('screen').account != 'ej@ynej')
// 信息监测路由判断账号菜单隐藏
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/datascreen',
    component: _ => import('@/views/datascreen/new'),
    hidden: true
  },
  {
    path: '/bigDataScreen',
    component: _ => import('@/views/datascreen/bigScreen'),
    hidden: true
  },
  {
    path: '/leaderScreen',
    component: _ => import('@/views/LeadScreen/index'),
    hidden: true
  },
  {
    path: '/newLeaderScreen',
    component: _ => import('@/views/LeadScreen/new_leader.vue'),
    hidden: true
  },
  {
    path: '/newDashboard',
    component: _ => import('@/views/LeadScreen/dashboard'),
    hidden: true
  },
  {
    path: '/departmentTotal',
    component: _ => import('@/views/LeadScreen/departmentTotal'),
    hidden: true
  },
  {
    path: '/areaTotal',
    component: _ => import('@/views/LeadScreen/areaTotal'),
    hidden: true
  },
  {
    path: '/departmentTotalDetail',
    component: _ => import('@/views/LeadScreen/departmentTotalDetail'),
    hidden: true
  },
  {
    path: '/newsSearchHref',
    component: _ => import('@/views/LeadScreen/newsSearchHref'),
    hidden: true
  },
  {
    path: '/newsSearch',
    component: _ => import('@/views/LeadScreen/newsSearch'),
    hidden: true
  },
  {
    path: '/riskPool',
    component: _ => import('@/views/LeadScreen/riskPool'),
    hidden: true
  },
  {
    path: '/acceptScreen',
    component: _ => import('@/views/AcceptScreen/index'),
    hidden: true
  },
  {
    path: '/totalAllScreen',
    component: _ => import('@/views/TotalScreen/index'),
    hidden: true
  },
  {
    path: '/totalOtherAllScreen',
    component: _ => import('@/views/TotalScreen/other'),
    hidden: true
  },
  {
    path: '/otherScreen',
    component: _ => import('@/views/otherScreen/index'),
    hidden: true
  },
  {
    path: '/otherScreen_wasted',
    component: _ => import('@/views/otherScreen/screen/type_second'),
    hidden: true
  },
  {
    path: '/otherScreen2',
    // component: _ => import('@/views/otherScreen/screen/type_third'),
    component: _ => import('@/views/otherScreen/screen/third_two'),
    hidden: true
  },
  {
    path: '/otherScreen3',
    component: _ => import('@/views/otherScreen/screen/type_fourth'),
    hidden: true
  },
  {
    path: '/otherScreen4',
    component: _ => import('@/views/otherScreen/screen/type_fifth'),
    hidden: true
  },
  {
    path: '/otherScreen5',
    component: _ => import('@/views/otherScreen/screen/type_sixth'),
    hidden: true
  },
  {
    path: '/otherScreen7',
    component: _ => import('@/views/otherScreen/screen/type_seven'),
    hidden: true
  },
  {
    path: '/circulateScreen',
    component: _ => import('@/views/otherScreen/circulateScreen'),
    hidden: true
  },
  {
    path: '/otherCirculateScreen',
    component: _ => import('@/views/otherScreen/otherCirculateScreen'),
    hidden: true
  },
  {
    path: '/searchContentList',
    component: _ => import('@/views/AllArticle/index'),
    hidden: true
  },
  {
    path: '/searchContentDetail',
    component: _ => import('@/views/AllArticle/detail'),
    hidden: true
  },
  {
    path: '/customerManager',
    component: _ => import('@/views/CustomerManager/index'),
    hidden: true
  },
  {
    path: '/taskManager',
    component: _ => import('@/views/TaskManager/index'),
    hidden: true,
    meta: { title: '任务约稿' }
  },
  {
    path: '/contentMsgDetail',
    component: _ => import('@/views/otherScreen/contentDetail'),
    hidden: true
  },
  {
    path: '/contentMsgList',
    component: _ => import('@/views/otherScreen/msgList'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/lockIe',
    component: () => import('@/views/lock'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/leaderScreen'
    // redirect: '/newDashboard'
  },

  {
    path: '/homePage',
    component: Layout,
    redirect: '/homePage/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '台账首页', icon: 'dashboard' }
    }]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/departmentStat',
    meta: { title: '统计', icon: 'warning' },
    hidden: true,
    children: [
      {
        path: 'departmentStat',
        name: 'departmentStat',
        component: _ => import('@/views/LeadScreen/departmentTotal'),
        meta: { title: '部门统计', icon: 'dashboard' }
      },
      {
        path: 'departmentTotalDetail',
        name: 'departmentTotalDetail',
        component: _ => import('@/views/LeadScreen/departmentTotalDetail'),
        meta: { title: '部门统计详情', icon: 'dashboard' },
        hidden: true
      },
      {
        path: 'areaStat',
        name: 'areaStat',
        component: _ => import('@/views/LeadScreen/areaTotal'),
        meta: { title: '地区统计', icon: 'dashboard' }
      },
      {
        path: 'areaTotalDetail',
        name: 'areaTotalDetail',
        component: _ => import('@/views/LeadScreen/areaTotalDetail'),
        meta: { title: '地区统计明细', icon: 'dashboard' },
        hidden: true
      },
      {
        path: 'newsSearchHref',
        name: 'newsSearchHref',
        component: _ => import('@/views/LeadScreen/newsSearchHref'),
        meta: { title: '地区统计明细', icon: 'dashboard' },
        hidden: true
      },
    ]
  },
  {
    path: '/monitor',
    component: Layout,
    redirect: '/monitor/monitorList',
    children: [
      {
        path: 'monitorList',
        name: 'monitorList',
        component: _ => import('@/views/monitor/index'),
        meta: { title: '信息监测', icon: 'dashboard' }
      }
    ],
    hidden: true
  },
  {
    path: '/outPost',
    component: Layout,
    redirect: '/outPost',
    children: [
      {
        path: 'post',
        name: 'post',
        component: _ => import('@/views/outPost/index'),
        meta: { title: '预警', icon: 'warning' }
      }
    ]
  },

  {
    path: '/topic',
    component: Layout,
    redirect: '/topic/topicList',
    children: [
      {
        path: 'topicList',
        name: 'topicList',
        component: _ => import('@/views/topic/index'),
        meta: { title: '选题', icon: 'warning' }
      }
    ]
  },

  {
    path: '/feature',
    component: Layout,
    redirect: '/feature/judge',
    children: [
      {
        path: 'judge',
        name: 'judge',
        component: _ => import('@/views/judge/index'),
        meta: { title: '其他', icon: 'warning' }
      }
    ]
  },

  {
    path: '/special',
    component: Layout,
    redirect: '/specialReport',
    children: [
      {
        path: 'specialReport',
        name: 'specialReport',
        component: _ => import('@/views/special/index'),
        meta: { title: '专报', icon: 'profressional' }
      }
    ]
  },

  {
    path: '/content',
    redirect: '/content/contentDetail',
    component: Layout,
    children: [
      {
        path: 'contentDetail',
        name: 'contentDetail',
        hidden: true,
        component: _ => import('@/views/analyze/detail'),
        meta: { title: '内容详情', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/daily',
    component: Layout,
    redirect: '/daily/dailyList',
    children: [
      {
        path: 'dailyList',
        name: 'dailyList',
        component: _ => import('@/views/daily/index'),
        meta: { title: '日报', icon: 'daily' }
      }
    ]
  },
  {
    path: '/weekly',
    component: Layout,
    redirect: '/weekly/weekReport',
    children: [
      {
        path: 'weekReport',
        name: 'weekReport',
        component: _ => import('@/views/weekly/index'),
        meta: { title: '周报', icon: 'week' }
      }
    ]
  },
  {
    path: '/monthly',
    component: Layout,
    redirect: '/monthly/monthReport',
    children: [
      {
        path: 'monthReport',
        name: 'monthReport',
        component: _ => import('@/views/monthly/index'),
        meta: { title: '月报', icon: 'month' }
      }
    ]
  },
  {
    path: '/quarterly',
    component: Layout,
    redirect: '/quarterly/quarterlyReport',
    children: [
      {
        path: 'quarterlyReport',
        name: 'quarterlyReport',
        component: _ => import('@/views/quarterly/index'),
        meta: { title: '季度报', icon: 'quarter' }
      }
    ]
  },
  {
    path: '/halfYear',
    component: Layout,
    redirect: '/halfYear/halfYearReport',
    children: [
      {
        path: 'halfYearReport',
        name: 'halfYearReport',
        component: _ => import('@/views/halfYear/index'),
        meta: { title: '半年报', icon: 'halfyear' }
      }
    ]
  },

  {
    path: '/year',
    component: Layout,
    redirect: '/year/yearReport',
    children: [
      {
        path: 'yearReport',
        name: 'yearReport',
        component: _ => import('@/views/year/index'),
        meta: { title: '年报', icon: 'year' }
      }
    ]
  },

  {
    path: '/searchContent',
    component: Layout,
    redirect: '/searchContent/searchAllContentList',
    children: [
      {
        path: 'searchAllContentList',
        name: 'searchAllContentList',
        component: _ => import('@/views/AllArticle/index'),
        meta: { title: '全站检索', icon: 'year' }
      }
    ]
  },
  {
    path: '/dataNew',
    component: _ => import('@/views/newScreen/index'),
    hidden: true
  },
  {
    path: '/full',
    component: _ => import('@/views/newScreen/full'),
    hidden: true
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

export const statisticRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/datascreen',
    component: _ => import('@/views/datascreen/new'),
    hidden: true
  },
  {
    path: '/bigDataScreen',
    component: _ => import('@/views/datascreen/bigScreen'),
    hidden: true
  },
  {
    path: '/leaderScreen',
    component: _ => import('@/views/LeadScreen/index'),
    hidden: true
  },
  {
    path: '/newDashboard',
    component: _ => import('@/views/LeadScreen/dashboard'),
    hidden: true
  },
  {
    path: '/departmentTotal',
    component: _ => import('@/views/LeadScreen/departmentTotal'),
    hidden: true
  },
  {
    path: '/areaTotal',
    component: _ => import('@/views/LeadScreen/areaTotal'),
    hidden: true
  },
  {
    path: '/departmentTotalDetail',
    component: _ => import('@/views/LeadScreen/departmentTotalDetail'),
    hidden: true
  },
  {
    path: '/newsSearchHref',
    component: _ => import('@/views/LeadScreen/newsSearchHref'),
    hidden: true
  },
  {
    path: '/newsSearch',
    component: _ => import('@/views/LeadScreen/newsSearch'),
    hidden: true
  },
  {
    path: '/riskPool',
    component: _ => import('@/views/LeadScreen/riskPool'),
    hidden: true
  },
  {
    path: '/acceptScreen',
    component: _ => import('@/views/AcceptScreen/index'),
    hidden: true
  },
  {
    path: '/totalAllScreen',
    component: _ => import('@/views/TotalScreen/index'),
    hidden: true
  },
  {
    path: '/totalOtherAllScreen',
    component: _ => import('@/views/TotalScreen/other'),
    hidden: true
  },
  {
    path: '/otherScreen',
    component: _ => import('@/views/otherScreen/index'),
    hidden: true
  },
  {
    path: '/otherScreen_wasted',
    component: _ => import('@/views/otherScreen/screen/type_second'),
    hidden: true
  },
  {
    path: '/otherScreen2',
    // component: _ => import('@/views/otherScreen/screen/type_third'),
    component: _ => import('@/views/otherScreen/screen/third_two'),
    hidden: true
  },
  {
    path: '/otherScreen3',
    component: _ => import('@/views/otherScreen/screen/type_fourth'),
    hidden: true
  },
  {
    path: '/otherScreen4',
    component: _ => import('@/views/otherScreen/screen/type_fifth'),
    hidden: true
  },
  {
    path: '/otherScreen5',
    component: _ => import('@/views/otherScreen/screen/type_sixth'),
    hidden: true
  },
  {
    path: '/otherScreen7',
    component: _ => import('@/views/otherScreen/screen/type_seven'),
    hidden: true
  },
  {
    path: '/circulateScreen',
    component: _ => import('@/views/otherScreen/circulateScreen'),
    hidden: true
  },
  {
    path: '/otherCirculateScreen',
    component: _ => import('@/views/otherScreen/otherCirculateScreen'),
    hidden: true
  },
  {
    path: '/searchContentList',
    component: _ => import('@/views/AllArticle/index'),
    hidden: true
  },
  {
    path: '/searchContentDetail',
    component: _ => import('@/views/AllArticle/detail'),
    hidden: true
  },
  {
    path: '/customerManager',
    component: _ => import('@/views/CustomerManager/index'),
    hidden: true
  },
  {
    path: '/taskManager',
    component: _ => import('@/views/TaskManager/index'),
    hidden: true,
    meta: { title: '任务约稿' }
  },
  {
    path: '/contentMsgDetail',
    component: _ => import('@/views/otherScreen/contentDetail'),
    hidden: true
  },
  {
    path: '/contentMsgList',
    component: _ => import('@/views/otherScreen/msgList'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/lockIe',
    component: () => import('@/views/lock'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/leaderScreen'
    // redirect: '/newDashboard'
  },

  {
    path: '/homePage',
    component: Layout,
    redirect: '/homePage/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '台账首页', icon: 'dashboard' }
    }]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/departmentStat',
    meta: { title: '统计', icon: 'warning' },
    children: [
      {
        path: 'departmentStat',
        name: 'departmentStat',
        component: _ => import('@/views/LeadScreen/departmentTotal'),
        meta: { title: '部门统计', icon: 'dashboard' }
      },
      {
        path: 'departmentTotalDetail',
        name: 'departmentTotalDetail',
        component: _ => import('@/views/LeadScreen/departmentTotalDetail'),
        meta: { title: '部门统计详情', icon: 'dashboard' },
        hidden: true
      },
      {
        path: 'areaStat',
        name: 'areaStat',
        component: _ => import('@/views/LeadScreen/areaTotal'),
        meta: { title: '地区统计', icon: 'dashboard' }
      },
      {
        path: 'newsSearchHref',
        name: 'newsSearchHref',
        component: _ => import('@/views/LeadScreen/newsSearchHref'),
        meta: { title: '地区统计明细', icon: 'dashboard' },
        hidden: true
      },
    ]
  },
  {
    path: '/monitor',
    component: Layout,
    redirect: '/monitor/monitorList',
    children: [
      {
        path: 'monitorList',
        name: 'monitorList',
        component: _ => import('@/views/monitor/index'),
        meta: { title: '信息监测', icon: 'dashboard' }
      }
    ],
    hidden: true
  },
  {
    path: '/outPost',
    component: Layout,
    redirect: '/outPost',
    children: [
      {
        path: 'post',
        name: 'post',
        component: _ => import('@/views/outPost/index'),
        meta: { title: '预警', icon: 'warning' }
      },
      {
        path: 'postDetail',
        name: 'postDetail',
        component: _ => import('@/views/outPost/detail'),
        meta: { title: '预警详情', icon: 'warning' },
        hidden: true
      }
    ]
  },

  {
    path: '/topic',
    component: Layout,
    redirect: '/topic/topicList',
    children: [
      {
        path: 'topicList',
        name: 'topicList',
        component: _ => import('@/views/topic/index'),
        meta: { title: '选题', icon: 'warning' }
      }
    ]
  },

  {
    path: '/feature',
    component: Layout,
    redirect: '/feature/judge',
    children: [
      {
        path: 'judge',
        name: 'judge',
        component: _ => import('@/views/judge/index'),
        meta: { title: '其他', icon: 'warning' }
      }
    ]
  },

  {
    path: '/special',
    component: Layout,
    redirect: '/specialReport',
    children: [
      {
        path: 'specialReport',
        name: 'specialReport',
        component: _ => import('@/views/special/index'),
        meta: { title: '专报', icon: 'profressional' }
      }
    ]
  },

  {
    path: '/content',
    redirect: '/content/contentDetail',
    component: Layout,
    children: [
      {
        path: 'contentDetail',
        name: 'contentDetail',
        hidden: true,
        component: _ => import('@/views/analyze/detail'),
        meta: { title: '内容详情', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/daily',
    component: Layout,
    redirect: '/daily/dailyList',
    children: [
      {
        path: 'dailyList',
        name: 'dailyList',
        component: _ => import('@/views/daily/index'),
        meta: { title: '日报', icon: 'daily' }
      }
    ]
  },
  {
    path: '/weekly',
    component: Layout,
    redirect: '/weekly/weekReport',
    children: [
      {
        path: 'weekReport',
        name: 'weekReport',
        component: _ => import('@/views/weekly/index'),
        meta: { title: '周报', icon: 'week' }
      }
    ]
  },
  {
    path: '/monthly',
    component: Layout,
    redirect: '/monthly/monthReport',
    children: [
      {
        path: 'monthReport',
        name: 'monthReport',
        component: _ => import('@/views/monthly/index'),
        meta: { title: '月报', icon: 'month' }
      }
    ]
  },
  {
    path: '/quarterly',
    component: Layout,
    redirect: '/quarterly/quarterlyReport',
    children: [
      {
        path: 'quarterlyReport',
        name: 'quarterlyReport',
        component: _ => import('@/views/quarterly/index'),
        meta: { title: '季度报', icon: 'quarter' }
      }
    ]
  },
  {
    path: '/halfYear',
    component: Layout,
    redirect: '/halfYear/halfYearReport',
    children: [
      {
        path: 'halfYearReport',
        name: 'halfYearReport',
        component: _ => import('@/views/halfYear/index'),
        meta: { title: '半年报', icon: 'halfyear' }
      }
    ]
  },

  {
    path: '/year',
    component: Layout,
    redirect: '/year/yearReport',
    children: [
      {
        path: 'yearReport',
        name: 'yearReport',
        component: _ => import('@/views/year/index'),
        meta: { title: '年报', icon: 'year' }
      }
    ]
  },

  {
    path: '/searchContent',
    component: Layout,
    redirect: '/searchContent/searchAllContentList',
    children: [
      {
        path: 'searchAllContentList',
        name: 'searchAllContentList',
        component: _ => import('@/views/AllArticle/index'),
        meta: { title: '全站检索', icon: 'year' }
      }
    ]
  },
  {
    path: '/dataNew',
    component: _ => import('@/views/newScreen/index'),
    hidden: true
  },
  {
    path: '/full',
    component: _ => import('@/views/newScreen/full'),
    hidden: true
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  mode: 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
